import styled from "styled-components";
import {GenericSideMenuLinkBox} from "./generic-side-menu-link.box";

export const DepositSideMenuLinkDefaultBox = styled(GenericSideMenuLinkBox)`
    padding: 1.6rem 1rem;
`;
